import Splide from '@splidejs/splide';

class AnimatedBarGraphCards {
  constructor(block) {
    this.block = block;
    this.barGraphCards = this.block.querySelectorAll('.bar_graph_card');
    this.sliderEl = this.block.querySelector('.splide');
    this.slider = null;
    this.bottomValue = this.block.getAttribute('data-bottom-value') || 0;
    this.breakpoint = this.block.getAttribute('data-breakpoint') || 991;
    
    this.sizeCards();
    this.configureSlider();
    this.resizeEvents();
  }

  sizeCards() {
    let maxValue = 0;
    this.barGraphCards.forEach((card) => {
      const value = parseFloat(card.getAttribute('data-card-value')) || this.bottomValue;
      if (value > maxValue) {
        maxValue = value;
      }
    });
    this.barGraphCards.forEach((card) => {
      const value = parseFloat(card.getAttribute('data-card-value')) || this.bottomValue;
      const percentage = ((value - this.bottomValue) / (maxValue - this.bottomValue)) * 100;
      card.style.height = `${percentage}%`;
      
      if(!card.classList.contains('sized')) {
        card.classList.add('sized');
      }
    });
  }

  configureSlider() {
    const isMobile = window.innerWidth <= this.breakpoint;

    if (isMobile && !this.slider) {
      this.slider = new Splide(this.sliderEl, {
        type: 'slide',
        perPage: 3,
        gap: '1rem',
        arrows: true,
        pagination: false,
        padding: {right: '8rem'},
        autoHeight: true,
        breakpoints: {
          768: {
            perPage: 2,
          },
          500: {
            perPage: 1,
            padding: {right: '6rem'}
          },
        }
      });

      this.slider.on( 'mounted', () => {
        setTimeout(() => {
          this.sizeCards();
        }, 700);
      } );
      
      this.slider.mount();
    } else if (!isMobile && this.slider) {
      this.slider.destroy(true);
      this.slider = null;
      this.sliderEl.classList.remove('is-initialized');
    }
  }

  resizeEvents() {
    let windowResizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(windowResizeTimeout);
      windowResizeTimeout = setTimeout(() => {
        this.sizeCards();
        this.configureSlider();
      }, 100);
    });
  }
}

export const InitAnimatedBarGraphCards = () => {
  const animatedBarGraphCards = document.querySelectorAll('.bar_graph_card__outer_wrap');

  if (animatedBarGraphCards.length) {
    animatedBarGraphCards.forEach((block) => {
      block.app = new AnimatedBarGraphCards(block);
    });
  }
}